module.exports = __webpack_public_path__ + "static/media/cashpresso.bf84f45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/cashpresso.png
// module id = 1574
// module chunks = 0